/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Microsoft_Tenant_Status_UnsetInputs */



/**
* | output |
* | --- |
* | "Not set: Microsoft accounts from any tenant are accepted." |
*
* @param {Microsoft_Tenant_Status_UnsetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const microsoft_tenant_status_unset = /** @type {((inputs?: Microsoft_Tenant_Status_UnsetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Microsoft_Tenant_Status_UnsetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht festgelegt: Microsoft-Konten aus jedem Mandanten werden akzeptiert.")
	return /** @type {LocalizedString} */ ("Not set: Microsoft accounts from any tenant are accepted.")
});